import { Component } from '@angular/core';
import { LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { ConfigurationServices } from '../../configuration/services';





@Component({
  selector: 'printer-sunmi-conf',
  templateUrl: 'printer-sunmi-conf.html',
})
export class PrinterSunmiConfPage {


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    public globals: Globals,
    public configurationServices: ConfigurationServices) {

  }

  updatePrintSunmiAuto(printauto) {
    this.globals.restaurant.print_auto_sunmi = printauto;
    this.configurationServices.afs.collection('restaurants').doc(this.globals.restaurant_uid).update({
      'print_auto_sunmi': printauto,
    });
  }
}



// WEBPACK FOOTER //
// ./src/pages/printer-sunmi/printer-sunmi-conf/printer-sunmi-conf.ts